import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TrustedForwarders from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/trusted-forwarders'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'trusted_forwarders_settings_index',
          component: TrustedForwarders,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
